export default {
  ExpenseNormRegulationList: {
    Title: 'Tiêu chuẩn định mức',
    AddBtnTitle: 'Thêm tiêu chuẩn định mức',
    NormDetailTitle: 'Chi tiết quy định',
    NoDataTitle: 'Chương trình đã có tiêu chuẩn định mức của Trung ương',
    NoDataTitleExtend: 'Vui lòng thêm những tiêu chuẩn của Địa phương và Đơn vị.',
    UserManual: 'Hướng dẫn sử dụng',
    DeleteMessage: 'Bạn có chắc chắn muốn xóa quy định về Tiêu chuẩn định mức không?',
  },

  ExpenseNormRegulationDetail: {
    Title: 'Thêm Tiêu chuẩn định mức',
    ExpenseNormRegulationName: 'Tên văn bản',
    ExpenseNormRegulationNamePlaceHolder: 'Nhập tên tóm tắt của văn bản',
    ExpenseNormRegulationContent: 'Nội dung văn bản',
    ExpenseNormRegulationContentPlaceHolder: 'Nhập hoặc sao chép nội dung tiêu chuẩn định mức vào đây',
    MaximumFileSize: 'Dung lượng tối đa 5MB. Hỗ trợ định dạng PDF, DOC, PNG, JPG',
    InvalidFileAttach: 'Tệp đính kèm không hợp lệ',
    NotSupportFileType: 'Phần mềm không hỗ trợ định dạng tệp tải lên: <b>{0}</b>.',
    OverMaximumSize: 'Tệp tài liệu có độ lớn vượt quá dung lượng cho phép. Vui lòng kiểm tra lại.',
  },
};
